import { BellOutlined } from "@ant-design/icons"
import { type EventContentArg } from "@fullcalendar/core"
import { Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface CalendarEventCellReminderProps {
  eventInfo: EventContentArg
}

export function CalendarEventCellReminder({
  eventInfo
}: CalendarEventCellReminderProps) {
  const event = eventInfo?.event
  const title = event?.title || ""
  const isCompleted = event?.extendedProps?.is_completed
  const isMonthView = eventInfo?.view?.type === "dayGridMonth"

  if (isMonthView) {
    return (
      <Flex
        align="center"
        gap={4}
        className={`size-full overflow-hidden ${isCompleted ? "line-through opacity-50" : ""}`}
      >
        <BellOutlined
          className="shrink-0"
          style={{ fontSize: "12px", color: `${eventInfo?.textColor}` }}
        />
        {eventInfo?.timeText && (
          <Text className="text-xs text-inherit opacity-80 leading-4 shrink-0">
            {eventInfo.timeText}
          </Text>
        )}
        <Text ellipsis className="text-xs text-inherit font-medium leading-4">
          {title}
        </Text>
      </Flex>
    )
  }

  return (
    <div
      className={`size-full overflow-hidden ${isCompleted ? "line-through opacity-50" : ""}`}
    >
      <Flex vertical>
        {eventInfo?.timeText && (
          <Text className="text-[10px] text-inherit opacity-75 leading-3 font-medium">
            {eventInfo.timeText}
          </Text>
        )}
        <Flex align={"center"} gap={4}>
          <BellOutlined
            className="shrink-0"
            style={{ fontSize: "12px", color: `${eventInfo?.textColor}` }}
          />
          <Text strong ellipsis className="text-[12px] text-inherit leading-4">
            {title}
          </Text>
        </Flex>
        {event?.extendedProps?.description && (
          <Text
            className={"text-[11px] text-inherit opacity-90 leading-3"}
            ellipsis={{
              tooltip: event?.extendedProps?.description
            }}
          >
            {event?.extendedProps?.description}
          </Text>
        )}
      </Flex>
    </div>
  )
}
